import { Component } from "react";
import carImage from "../../assets/img/modal2.jpg";

class vehicleSimulator extends Component<any, any> {
  stepper: any;
  constructor(props: any) {
    super(props);
    this.state = {
      deviceID: "",
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const deviceid = queryParams.get("deviceid");
    console.info(deviceid);
    this.setState({ deviceID: deviceid });
  }

  handleChange = (event: any) => {
    const selectedResultCodeOption = event.target.value;
    this.props.onResultCodeOptionChange(selectedResultCodeOption);
  };

  render() {
    const { resultcodedb } = this.props;
    console.log(this.props);
    return (
      <div className="col-6">
        {/* <h5>VIN : {this.state.deviceID}</h5> */}
        <div className="car_model bg-white shadow-3 p-3 text-center position-relative">
          <img src={carImage} alt="model" title="Car" />
          <div className="img_wrapper">
            <a
              href="#"
              id="door_FDL"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("door_FDL");
              }}
              className={
                "CarPoints FDL " +
                (this.props.vehicalStateData.door_FDL ? "on" : "off")
              }
              title="Front Door Left "
            ></a>
            <a
              href="#"
              id="door_FDR"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("door_FDR");
              }}
              className={
                "CarPoints FDR " +
                (this.props.vehicalStateData.door_FDR ? "on" : "off")
              }
              title="Front Door Right"
            ></a>
            <a
              href="#"
              id="door_RDL"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("door_RDL");
              }}
              className={
                "CarPoints RDL " +
                (this.props.vehicalStateData.door_RDL ? "on" : "off")
              }
              title="Rear Door Left"
            ></a>
            <a
              href="#"
              id="door_RDR"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("door_RDR");
              }}
              className={
                "CarPoints RDR " +
                (this.props.vehicalStateData.door_RDR ? "on" : "off")
              }
              title="Rear Door Right"
            ></a>
            <a
              href="#"
              id="cabin_outSts"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("cabin_outSts");
              }}
              className={
                "CarPoints outSts " +
                (this.props.vehicalStateData.cabin_outSts ? "on" : "off")
              }
              title="Cabin"
            ></a>
            <a
              href="#"
              id="engine_sts"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("engine_sts");
              }}
              className={
                "CarPoints BCD " +
                (this.props.vehicalStateData.engine_sts ? "on" : "off")
              }
              title="Engine"
            ></a>
            <a
              href="#"
              id="seat_RStRem"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("seat_RStRem");
              }}
              className={
                "CarPoints FCD " +
                (this.props.vehicalStateData.seat_RStRem ? "on" : "off")
              }
              title="Rear Seat Remainder"
            ></a>

            <a
              href="#"
              id="extendedOpenings_trunk"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("extendedOpenings_trunk");
              }}
              className={
                "CarPoints Trunk " +
                (this.props.vehicalStateData.extendedOpenings_trunk
                  ? "on"
                  : "off")
              }
              title="ExtendedOpenings Trunk"
            ></a>
            <a
              href="#"
              id="extendedOpenings_roof"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("extendedOpenings_roof");
              }}
              className={
                "CarPoints Roof " +
                (this.props.vehicalStateData.extendedOpenings_roof
                  ? "on"
                  : "off")
              }
              title="ExtendedOpenings Roof"
            ></a>
            {/* <a href="#" id="windows_FWR" onClick={(e) => { e.preventDefault(); this.props.handleClick1('windows_FWR') }} className={"CarPoints FWR " + (this.props.vehicalStateData.windows_FWR ? 'on' : 'off')} title="Windows FWR"></a>
                        <a href="#" id="windows_FWL" onClick={(e) => { e.preventDefault(); this.props.handleClick1('windows_FWL') }} className={"CarPoints FWL " + (this.props.vehicalStateData.windows_FWL ? 'on' : 'off')} title="Windows FWL"></a>
                        <a href="#" id="windows_RWL" onClick={(e) => { e.preventDefault(); this.props.handleClick1('windows_RWL') }} className={"CarPoints RWL " + (this.props.vehicalStateData.windows_RWL ? 'on' : 'off')} title="Windows RWL"></a>
                        <a href="#" id="windows_RWR" onClick={(e) => { e.preventDefault(); this.props.handleClick1('windows_RWR') }} className={"CarPoints RWR " + (this.props.vehicalStateData.windows_RWR ? 'on' : 'off')} title="Windows RWR"></a> 
                        <a href="#" id="windows_snRf" onClick={(e) => { e.preventDefault(); this.props.handleClick1('windows_snRf') }} className={"CarPoints snRf " + (this.props.vehicalStateData.windows_snRf ? 'on' : 'off')} title="Windows snRf"></a> */}
            <a
              href="#"
              id="alerts_Horn"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("alerts_Horn");
              }}
              className={
                "CarPoints Horn " +
                (this.props.vehicalStateData.alerts_Horn ? "on" : "off")
              }
              title="Alerts Horn"
            ></a>
            <a
              href="#"
              id="alerts_Buzzer"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("alerts_Buzzer");
              }}
              className={
                "CarPoints Buzzer " +
                (this.props.vehicalStateData.alerts_Buzzer ? "on" : "off")
              }
              title="Alerts Buzzer"
            ></a>
            <a
              href="#"
              id="alerts_Hazards"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("alerts_Hazards");
              }}
              className={
                "CarPoints Hazards " +
                (this.props.vehicalStateData.alerts_Hazards ? "on" : "off")
              }
              title="Alerts Hazards"
            ></a>
            <a
              href="#"
              id="lamps_FL"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("lamps_FL");
              }}
              className={
                "CarPoints FL " +
                (this.props.vehicalStateData.lamps_FL ? "on" : "off")
              }
              title="Lamps FL"
            ></a>
            <a
              href="#"
              id="lamps_RL"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("lamps_RL");
              }}
              className={
                "CarPoints RL " +
                (this.props.vehicalStateData.lamps_RL ? "on" : "off")
              }
              title="Lamps RL"
            ></a>
            <a
              href="#"
              id="lamps_Hazards"
              onClick={(e) => {
                e.preventDefault();
                this.props.handleClick1("lamps_Hazards");
              }}
              className={
                "CarPoints LampsHazard " +
                (this.props.vehicalStateData.lamps_Hazards ? "on" : "off")
              }
              title="Lamps Hazards"
            ></a>
          </div>
        </div>
        <h4
          style={{
            fontSize: "14px",
            marginLeft: "30%",
            marginRight: "10%",
            marginTop: "3%",
            color: "#ff0000",
          }}
        >
          Existing Result Code : {resultcodedb}
          <select
            onChange={this.handleChange}
            id="resulttopic"
            style={{
              width: "40%",
              padding: "8px",
              fontSize: "13px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              backgroundColor: "#fff",
              marginLeft: "4%",
            }}
          >
            <option value="" disabled selected>
              Select New Result Code
            </option>
            <option value="01">01</option>
            <option value="02">02</option>
            <option value="03">03</option>
            <option value="0A">0A</option>
            <option value="0B">0B</option>
            <option value="0C">0C</option>
            <option value="0D">0D</option>
            <option value="0E">0E</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="30">30</option>
            <option value="32">32</option>
            <option value="33">33</option>
            <option value="40">40</option>
            <option value="60">60</option>
            <option value="61">61</option>
            <option value="62">62</option>
            <option value="63">63</option>
            <option value="64">64</option>
            <option value="65">65</option>
            <option value="66">66</option>
            <option value="80">80</option>
            <option value="B0">B0</option>
            <option value="C0">C0</option>
            <option value="C1">C1</option>
            <option value="C2">C2</option>
            <option value="D0">D0</option>
            <option value="D1">D1</option>
            <option value="D2">D2</option>
            <option value="D3">D3</option>
            <option value="D4">D4</option>
            <option value="D5">D5</option>
            <option value="D6">D6</option>
            <option value="D7">D7</option>
            <option value="D8">D8</option>
            <option value="D9">D9</option>
            <option value="DA">DA</option>
            <option value="DB">DB</option>
            <option value="DC">DC</option>
            <option value="DD">DD</option>
            <option value="DE">DE</option>
            <option value="DF">DF</option>
            <option value="E0">E0</option>
            <option value="E1">E1</option>
            <option value="E3">E3</option>
            <option value="E4">E4</option>
            <option value="E5">E5</option>
            <option value="E6">E6</option>
            <option value="E7">E7</option>
            <option value="E8">E8</option>
            <option value="E9">E9</option>
            <option value="EA">EA</option>
            <option value="EB">EB</option>
            <option value="EC">EC</option>
            <option value="ED">ED</option>
            <option value="EE">EE</option>
            <option value="EF">EF</option>
            <option value="F0">F0</option>
            <option value="F1">F1</option>
            <option value="F2">F2</option>
            <option value="F3">F3</option>
            <option value="F4">F4</option>
            <option value="F5">F5</option>
            <option value="F6">F6</option>
            <option value="F7">F7</option>
            <option value="F8">F8</option>
            <option value="F9">F9</option>
            <option value="FA">FA</option>
            <option value="FB">FB</option>
            <option value="FC">FC</option>
            <option value="FD">FD</option>
            <option value="FE">FE</option>
            <option value="FF">FF</option>
          </select>
        </h4>
      </div>
    );
  }
}

export default vehicleSimulator;
